import UserDetails from "../api/classes/UserDetails";
import jsCookies from "js-cookie";
import api from "../api";
import XLSX from "xlsx";

export default {
    state: {
        colors: {},
        userDetails: {},
        error: false,
        errorDetails: {},
        loading: true,
        loadingText: '',
        isMobile: false,
        showIframeModal: false,
        iframeLink: '',
        deptLoading: true,
        calloutLoading: true,
        openIssuesLoading: true,
        maintenancesLoading: true,
        layout: {
            hideSidebar: false,
            hideToolbar: false,
            skipFirstTime: false,
        }
    },
    actions: {
        exportToExcel({}, name) {
            let table = document.querySelector('#table table');
            let wb = XLSX.utils.table_to_book(table, {sheet: "Sheet JS"});
            XLSX.writeFile(wb, name + '.xlsx')
        },
        authenticateCookie({dispatch}) {
            jsCookies.remove('session');
            const cookie = jsCookies.get('auth');
            return dispatch('getSubscriptionViaToken', cookie)
        },
        getUserDetailsFromSession({commit,dispatch}) {
            if (jsCookies.get('session')) {
                let userDetails = JSON.parse(jsCookies.get('session'));
                commit('setUserDetails', userDetails)
                dispatch('init')
            }
        },
        getSubscriptionViaToken({state, commit,dispatch}, token) {
            return api.login.getSubscriptionViaToken(token).then(
                userDetails => {
                    commit('setUserDetails', userDetails);
                    commit('setSessionCookie');
                    commit('hideLoading');
                    dispatch('init')
                    return Promise.resolve(state.userDetails)
                }).catch(err => {
                commit('showError')
                commit('logout')
            })
                .finally(e => {
                    commit('hideLoading')
                })
        },
        getSubscriptionDetails({state, commit,dispatch}, {username, password, rememberMe}) {
            commit('showLoading');
            return api.login.getSubscriptionDetails(username, password, rememberMe).then(
                userDetails => {
                    commit('setUserDetails', userDetails);
                    commit('setSessionCookie');
                    if (userDetails.Token) {
                        commit('setRememberMeCookie', userDetails.Token);
                    }
                    dispatch('init')
                    commit('hideLoading');
                    return Promise.resolve(state.userDetails)
                }).finally(e => {
                commit('hideLoading')
            })
        },

    },
    mutations: {
        setCalloutLoading(state, value) {
            state.calloutLoading = value;
        },
        setOpenDeptsLoading( state, value) {
            state.deptLoading = value;
        },
        setOpenIssuesLoading(state, value) {
            state.openIssuesLoading = value;
        },
        setMaintenancesLoading(state, value) {
            state.maintenancesLoading= value;
        },
        setLayoutView(mode) {
            if (mode === 'qrcode') {
                state.layout.skipFirstTime = true;
            }
            if (mode === 'onepage') {
                state.layout.hideSidebar = true;
                state.layout.hideToolbar = true;
            }
        },
        toggleIframeModal(state, {link}) {
            state.showIframeModal = !state.showIframeModal;
            if (state.showIframeModal) {
                state.iframeLink = link
            } else {
                state.iframeLink = null;
            }
        },
        setUserDetails(state, userDetails) {
            if (userDetails instanceof UserDetails) {
                state.userDetails = userDetails;
                state.colors = userDetails.Office.Colors;
            } else {
                state.userDetails = new UserDetails(userDetails);
                state.colors = userDetails.Office.Colors;
            }
        },
        setRememberMeCookie(state) {
            jsCookies.set('auth', state.userDetails.Token, {expires: 30})
        },
        setSessionCookie(state) {
            jsCookies.set('session', JSON.stringify(state.userDetails))
        },

        logout(state) {
            state.userDetails = {};
            jsCookies.remove('auth');
            jsCookies.remove('session');
        },
        setLoadingMessage(state, message) {
            state.loadingText = message
        },
        showError(state) {
            state.errorText = "Υπήρξε κάποιο πρόβλημα";
            state.error = true;
        },
        hideError(state,) {
            state.error = false;
        },
        showLoading(state, message) {
            state.loadingText = "Παρακαλώ περιμένετε";
            state.loading = true;
        },
        hideLoading(state) {
            state.loading = false
        },
        setMobile(state, isMobile) {
            state.isMobile = isMobile
        },
        setErrorDetails(state, error) {
            state.errorDetails = error;
        },

    },
    getters: {
        layout: s=> s.layout,
        calloutLoading: s => s.calloutLoading,
        deptLoading: s => s.deptLoading,
        openIssuesLoading: s => s.openIssuesLoading,
        maintenancesLoading: s => s.maintenancesLoading,
        showIframeModal: s => s.showIframeModal,
        iframeLink: s => s.iframeLink,
        colors: s => s.colors,
        loading: s => s.loading,
        loadingText: s => s.loadingText,
        errorDetails: s => s.errorDetails,
        error: s => s.error,
        userDetails: s => s.userDetails,
        isMobile: s => s.isMobile,
        token: () => jsCookies.get('auth')

    }
}
